module.exports = __webpack_public_path__ + "media/icons/heart_filled-c4f8a37b.svg";